<template>
  <MainLayout section="guides">
    <LightBox :items="images" :index="imageIndex" />

    <b-row class="guide_content">
      <b-col>
        <b-row>
          <b-col>
            <h1><router-link to="/guides">Guides</router-link> / NFT Tracking</h1>
          </b-col>
        </b-row>

        <b-row>
          <b-col>
            <p>
            In this guide we'll demonstate how Block Trac can be used to quickly be notified of DLT transactions involving a NFT of interest.
            </p>

            <center>
              <iframe :width="mq_lte_sm ? 300 : 560" :height="mq_lte_sm ? 170 : 315" src="https://www.youtube.com/embed/ob-yi5QjbJU?start=96" title="Block Trac - NFTs" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen></iframe>
            </center>
          </b-col>
        </b-row>

        <b-row class="guide_section">
          <b-col>
            <h2>Creating the Filter</h2>

            <p>Starting from <router-link to="/txs">Block Trac</router-link>, to create a filter that track a NFT. First select the blockchain that supports NFT transfer.</p>

            <img :src="require('@/assets/guides/nftracking/blockchain2.gif')" @click="set_image" :class="mq_gt_sm ? 'half_width' : null" />
          </b-col>
        </b-row>

        <b-row class="guide_subsection">
          <b-col>
            <p>Then check the Help Icon (<b>?</b>) underneath the <i>Filter Expression Box</i></p>

            <img :src="require('@/assets/guides/nftracking/expression-help2.gif')" @click="set_image" :class="mq_gt_sm ? 'half_width' : null" />
          </b-col>
        </b-row>

        <b-row class="guide_section">
          <b-col>
            <p>This will bring up a list of customizable expressions which you can use to filter transactions.</p>

            <p>Click on the expression corresponding to <i>Viewing transactions that involve the specified NFT</i></p>

            <img :src="require('@/assets/guides/nftracking/nft-expression.png')" @click="set_image" :class="mq_gt_sm ? 'half_width' : null" />
          </b-col>
        </b-row>

        <b-row class="guide_section">
          <b-col>
            <h2>Specifying the NFT</h2>

            <p>Now that Filter Expression Box will contain the expression to track a NFT, we need to specify the exact NFT that we can to track.</p>

            <p>Replace &lt;NFT_ID&gt; in the Filter Expression Box with the ID of our target NFT.</p>

            <img :src="require('@/assets/guides/nftracking/nft-id.gif')" @click="set_image" />
          </b-col>
        </b-row>

        <b-row class="guide_subsection">
          <b-col>
            <b-alert show variant="warning">
              <img :src="require('@/assets/exclamation.svg')" width="25" />
              <span><b>Pro-Tip</b>: check the marketplace that the NFT was minted for its ID!</span>
            </b-alert>
          </b-col>
        </b-row>

        <b-row class="guide_section">
          <b-col>
            <h2>Receiving alerts</h2>

            <p>Click <b>"Save to filter"</b> next to the Filter Expression Box to save it</p>

            <p>Give your filter a name</p>

            <p>If you are logged in, here you may specify an email address where to receive alerts.</p>

            <b-alert show>
              <img :src="require('@/assets/phone.svg')" width="25" />
              <span>Higher tiered plans may specify a mobile phone number and/or webhook endpoints which to receive alerts. See <router-link to="/plans">Plans</router-link> for more information.</span>
            </b-alert>

            <img :src="require('@/assets/guides/nftracking/sms-sink.png')" @click="set_image" :class="mq_gt_sm ? 'half_width' : null" />
          </b-col>
        </b-row>

        <b-row class="guide_subsection">
          <b-col>
            <p>Click <b>"Create Filter"</b>.</p>

            <p>
            If you are not logged in, you will be prompted to register or login to finish the process.
            </p>

            <h4>Now you will receive alerts whenever the NFT you are interested is moved or involved in a transactions!</h4>
          </b-col>
        </b-row>

        <b-row class="guide_section">
          <b-col>
            <h2>Next steps</h2>
            <p>Return to <router-link to="/guides">Guides</router-link> to learn about more types of DLT activity that you can monitor.</p>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </MainLayout>
</template>

<script>
  import MainLayout from '../components/MainLayout'
  import LightBox from '../components/LightBox'
  import Blockchain from '../mixins/blockchain'

  export default{
    mixins : [Blockchain],

    components: {
      MainLayout,
      LightBox
    },

    data (){
      return {
        imageIndex : null,
        images : []
      }
    },

    methods : {
      set_image (evnt){
        this.images = [evnt.target.src];
        this.imageIndex = 0;
      }
    },

    mounted (){
      this.images = [];
      this.imageIndex = null;
    }
  }
</script>
